import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "semantic-ui-css/semantic.min.css";
import "react-calendar/dist/Calendar.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./app/layout/styles.css";
import reportWebVitals from "./reportWebVitals";
import { store, StoreContext } from "./app/stores/store";
import {
  RouterProvider,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { router } from "./app/router/Routes";
import {
  ConsoleInstrumentation,
  ErrorsInstrumentation,
  FaroErrorBoundary,
  LogLevel,
  WebVitalsInstrumentation,
  withFaroRouterInstrumentation,
  FaroRoutes,
  faro
} from "@grafana/faro-react";

import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";
import { Resource } from '@opentelemetry/resources';
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { UserProfile } from "./app/models/user";
import agent from "./app/api/agent";

const encryptedProfile = localStorage.getItem("user");

let decryptedProfile: UserProfile | null = null;

if (encryptedProfile) {
  try {
    decryptedProfile = agent.decryptResponse(encryptedProfile) || null;
  } catch (error) {
    decryptedProfile = null; // Set to null if decryption fails
  }
}


initializeFaro({
  url: String(process.env.REACT_APP_FaroUrl),
  apiKey : String(process.env.REACT_APP_FaroApiKey),
  app: {
    name: String(process.env.REACT_APP_FaroAppName),
    version: String(process.env.REACT_APP_FaroAppVersion),
    environment: String(process.env.REACT_APP_FaroAppEnvironment),
  },

  // user: {
  //   // Optional, if you want to pass the user ID
  //   id:  decryptedProfile ? decryptedProfile.userId : "",
  
  //   // Optional, if you want to pass the user email
  //   email:  decryptedProfile ? decryptedProfile.email : "",
  
  //   // // Optional, if you want to pass the username
  //   // username: String(process.env.REACT_APP_FARO_USERNAME) || "",
  
  //   // Optional, if you want to set custom attributes
  // //  attributes: {
  // //     'my-custom-attribute': String(process.env.REACT_APP_FARO_USERNAME),
  // //   },
  // },
  instrumentations: [
    // Mandatory, omits default instrumentations otherwise.
    ...getWebInstrumentations(),
    // Tracing package to get end-to-end visibility for HTTP requests.
    new TracingInstrumentation(),
    // New stuff added 16/07/2024
    new ErrorsInstrumentation(),
    new WebVitalsInstrumentation(),
    new ConsoleInstrumentation({
      disabledLevels: [LogLevel.TRACE, LogLevel.ERROR], // console.log will be captured
    }),

    // React integration for React applications.
    new ReactIntegration({
      router: createReactRouterV6Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType,
      }),
    }),
  ],

 
});



// set up otel
const resource = Resource.default().merge(
  new Resource({
    [SEMRESATTRS_SERVICE_NAME]: String(process.env.REACT_APP_FaroAppName),
    [SEMRESATTRS_SERVICE_VERSION]: String(process.env.REACT_APP_FaroAppVersion),
  })
);



const provider = new WebTracerProvider({ resource });
const browserRouter = withFaroRouterInstrumentation(router);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StoreContext.Provider value={store}>
    <FaroErrorBoundary>
      <RouterProvider router={browserRouter} />
    </FaroErrorBoundary>
  </StoreContext.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
